export default {
  adminHome: '/sistema/administrador',
  adminLogbooks: '/sistema/administrador/avances',
  adminNewCandidate: '/sistema/administrador/nuevo-candidato',
  applicantAdjustments: '/sistema/candidato/ajuste',
  candidateHome: '/sistema/candidato',
  clausesAcceptance: '/sistema/candidato/clausulas',
  analystAdmin: '/sistema/analista/estudio',
  analystHome: '/sistema/analista',
  login: '/sistema',
  signOut: '/signout',
};
